<template>
  <nav class="nav" :class="{ on: isMenu }" v-if="routeLayout.isMenu">
    <div class="nav-con">
      <div class="nav-header">
        <h1 class="logo"></h1>
        <!--        <button class="btn-close" @click="fnToggle"></button>-->
        <button class="btn-close" onclick="document.querySelector('.nav').classList.remove('on');"></button>
        <!--                onclick="document.querySelector('.nav').classList.remove('on');"-->
      </div>
      <div class="nav-sect">
        <div class="top">
          <div class="nav-name">
            <strong> {{ userName }}</strong>
            <span>님</span>
          </div>
          <ul class="nav-list">
            <li @click="fnPage('/class/list')">수업 리스트</li>
            <li @click="fnPage('/alarm/list')">알립니다</li>
            <li @click="fnPage('/payment/list')">수강료 납부내역</li>
            <li @click="fnPage('/user/edit')">개인정보 수정</li>
          </ul>
          <ul class="nav-list">
            <li @click="fnPage('/notice/list')">공지사항</li>
            <li @click="fnPage('/faq')">FAQ</li>
            <li @click="fnModal('/terms')">이용약관</li>
            <li @click="fnPage('/push')">푸시알림 설정</li>
          </ul>
        </div>
        <div class="btn-wrap">
          <button class="btn-txt" @click="fnLogoutModal">로그아웃</button>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'MENU'
};
</script>

<script setup>
import LOGOUT_MODAL from '@/components/common/modal/alert/confirm/logout.vue';
import TERMS from '@/components/common/modal/terms/index.vue';
import { computed, onBeforeUpdate, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

const { getters, dispatch } = useStore();
const router = useRouter();

const userName = ref('');

onBeforeUpdate(() => {
  const userData = computed(() => getters['user/getUserData']);
  userName.value = userData.value.name;
});

const routeLayout = computed(() => {
  return getters['layout/getRouteLayout'];
});

const isMenu = computed(() => getters['layout/getIsShowMenu']);

const fnPage = path => router.push({ path: path });
const fnModal = async () => {
  await dispatch('layout/pushModalComponent', {
    component: TERMS,
    callBack: async proxy => {
      await proxy.$emit('close');
    }
  });
};

const fnClose = () => {
  dispatch('layout/removeAllModalComponent');
};

const fnLogoutModal = async () => {
  await dispatch('layout/pushModalComponent', {
    component: LOGOUT_MODAL,
    callBack: async proxy => {
      await proxy.$emit('close');
    }
  });
};
</script>
